import React, { memo, useRef } from "react";
import { useDragLayer } from "react-dnd";
import PackAssetDragLayerView from "./PackAssetDragLayerView";

import "./packAssetDragLayer.scss"; // Copy styles from AssetDragLayer

interface Props {
  cardWidth?: number;
}

const PackAssetDragLayer: React.FC<Props> = ({ cardWidth }): React.ReactElement | null => {
  const container = useRef<HTMLDivElement>(null);
  const { isDragging, item, clientOffset } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    isDragging: monitor.isDragging(),
    clientOffset: monitor.getClientOffset(),
  }));

  return isDragging && item?.id ? (
    <div ref={container} className="pack-asset-dragging-layer">
      <PackAssetDragLayerView cardWidth={cardWidth} container={container} item={item} clientOffset={clientOffset} />
    </div>
  ) : null;
};

export default memo(PackAssetDragLayer);
